import { NA, validateStringData } from 'utils/formatting';

export const getImgBase64Src = (contentBase64) => `data:image;base64,${contentBase64}`;
export const adaptClientInformation = (data, options) => {
    const t = options?.t || ((d) => d);
    const getFormattedDate = options?.getFormattedDate || ((d) => d);
    const getFormattedPhoneNumber = options?.getFormattedPhoneNumber || ((d) => d);
    const getSchemaLabelById = options?.getSchemaLabelById || ((d) => d);

    const {
        personalInformation,
        communicationMethods,
        relationshipInformation,
        investmentInformation,
        taxSituation,
    } = data || {};

    const phone = `${personalInformation?.primaryPhoneNumber || ''}`;

    return {
        LastName: personalInformation?.lastName,
        FirstName: personalInformation?.firstName,
        Salutation: getSchemaLabelById(personalInformation?.salutation?.value),
        Name: personalInformation?.displayName || '',
        dateOfDeath: personalInformation?.extDateOfDeath || null,
        IsProspect: relationshipInformation?.isProspect || false,
        ExternalId: relationshipInformation?.externalId || null,
        HasRiskProfile: !!investmentInformation?.chosenRiskCategory?.value,
        Contacts: [
            {
                Information: {
                    title: t('clientDashboard.overview.contacts.email'),
                    subtitle: validateStringData(personalInformation?.primaryEmail),
                },
                Icon: {
                    type: 'envolope',
                    size: 20,
                    href: personalInformation?.primaryEmail ? `mailto:${personalInformation?.primaryEmail}` : undefined,
                    className: 'information-email',
                },
            },
            {
                Information: {
                    title: t('clientDashboard.overview.contacts.phone'),
                    subtitle: getFormattedPhoneNumber(validateStringData(phone)),
                },
                Icon: {
                    type: 'phone-call',
                    size: 20,
                    href: phone !== '' ? `tel:${phone}` : undefined,
                    className: 'information-phone',
                },
            },
            {
                Information: {
                    title: t('clientDashboard.overview.contacts.mobile'),
                    subtitle: getFormattedPhoneNumber(validateStringData(phone)),
                },
                Icon: {
                    type: 'phone-call',
                    size: 20,
                    href: phone !== '' ? `tel:${phone}` : undefined,
                    className: 'information-mobile',
                },
            },
            {
                Information: {
                    title: t('clientDashboard.overview.contacts.dateOfBirth'),
                    subtitle: getFormattedDate(personalInformation?.dateOfBirth),
                },
                Icon: { type: '' },
            }],
        Street: personalInformation?.primaryAddressLine1 ?? NA,
        StreetNumber: personalInformation?.primaryAddressStreet ?? NA,
        City: personalInformation?.primaryAddressCity || '',
        PostalCode: personalInformation?.primaryAddressPostalCode
            || personalInformation?.primaryAddressLine2 || '',
        Country: getSchemaLabelById(personalInformation?.primaryAddressCountry?.value) ?? NA,
        State: communicationMethods?.primaryAddress?.primaryAddressLine6 ?? '',
        PhoneNumber: phone !== '' ? phone : NA,
        ChosenRiskCategory: getSchemaLabelById(investmentInformation?.chosenRiskCategory?.value)
            || NA,
        TaxSituation: taxSituation || {},
    };
};
